import React, { useEffect, useState } from "react";

import platformsService, { PlatformCourseDTO } from "../../services/v2/platforms.service";
import { errorText } from "../../navigation/v2/managment/enrollmentRequests/helpers";
import { PromptModal } from "../../navigation/v2/managment/enrollmentUpdates/piezas";
import { fechaBonita } from "../../utils/fechaBonita";
import { montoBonito } from "../../utils/monto";

import "../../navigation/v2/managment/enrollmentUpdates/styles.css";

/** Cursos y Talleres: precio mensual de una plataforma en cada moneda. No pinta nada si el curso no es plataforma. */
export const PreciosPlataforma: React.FC<{ campusId: number; courseId: number; puedeEditar: boolean }> = ({ campusId, courseId, puedeEditar }) => {
	const [curso, setCurso] = useState<PlatformCourseDTO | null>(null);
	const [borrador, setBorrador] = useState<{ [currencyId: number]: string } | null>(null);
	const [busy, setBusy] = useState<boolean>(false);
	const [aviso, setAviso] = useState<{ text: string; ok: boolean } | null>(null);

	const cargar = () => platformsService.list(campusId)
		.then(r => setCurso((Array.isArray(r.data) ? r.data : []).find(c => c.courseId === courseId) || null))
		.catch(() => setCurso(null));
	useEffect(() => { cargar();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campusId, courseId]);
	if (!curso) return null;

	const guardar = async () => {
		if (!borrador) return;
		setBusy(true); setAviso(null);
		try {
			for (const p of curso.prices) {
				const v = (borrador[p.currencyId] ?? "").trim();
				const nuevo = v === "" ? null : Number(v);
				if (nuevo !== p.monthlyPrice) await platformsService.setPrice(campusId, courseId, p.currencyId, nuevo);
			}
			setBorrador(null); setAviso({ text: "Precios guardados.", ok: true }); await cargar();
		} catch (e) { setAviso({ text: errorText(e), ok: false }); }
		setBusy(false);
	};

	return (
		<div className="wau" style={{ padding: "0 15px 15px 15px" }}>
			<div className="wau-caja">
				<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, marginBottom: 10 }}>
					<h3 style={{ margin: 0 }}>Precios por moneda</h3>
					<span className="wau-sec wau-num" style={{ fontSize: 13 }}>{curso.activeSubscriptions} activas</span>
					{!puedeEditar ? null : borrador
						? <div className="wau-acciones" style={{ marginTop: 0 }}>
							<button type="button" className="wau-btn s mini" disabled={busy} onClick={() => setBorrador(null)}>Volver</button>
							<button type="button" className="wau-btn p mini" disabled={busy} onClick={guardar}>Guardar</button>
						</div>
						: <button type="button" className="wau-btn s mini" onClick={() => setBorrador(Object.fromEntries(curso.prices.map(p => [p.currencyId, p.monthlyPrice == null ? "" : String(p.monthlyPrice)])))}>Editar</button>}
				</div>
				{aviso ? <div className={"wau-aviso " + (aviso.ok ? "ok" : "mal")}><span>{aviso.text}</span></div> : null}
				<div className="wau-fila">
					{curso.prices.map(p => (
						<label key={p.currencyId} className="wau-campo" style={{ width: 150 }}><span className="wau-lab">{p.code}{p.currencyId === curso.campusCurrencyId ? " · plantel" : ""}</span>
							{borrador
								? <input className="wau-entrada wau-num" type="number" min={0} step="0.01" style={{ textAlign: "right" }} value={borrador[p.currencyId] ?? ""}
									onChange={e => setBorrador({ ...borrador, [p.currencyId]: e.target.value })} />
								: <b className={"wau-num" + (p.monthlyPrice == null ? " wau-oro" : "")} style={{ fontSize: 15 }}>{p.monthlyPrice == null ? "Sin precio" : `${p.symbol} ${montoBonito(p.monthlyPrice)}`}</b>}
						</label>
					))}
				</div>
			</div>
		</div>
	);
};

/** Estado de cuenta: "Acceso hasta <fecha>" y "Regalar mes" (nota obligatoria) de una matrícula de plataforma. */
export const AccesoPlataforma: React.FC<{ campusId: number; enrollmentId: number; accessUntil?: string | null; puedeRegalar: boolean; onChanged: () => void }> =
	({ campusId, enrollmentId, accessUntil, puedeRegalar, onChanged }) => {
		const [regalar, setRegalar] = useState<boolean>(false);
		const [busy, setBusy] = useState<boolean>(false);
		const [error, setError] = useState<string | null>(null);
		return (
			<div className="wau" style={{ padding: 0 }}>
				<div className="wau-acciones" style={{ justifyContent: "flex-start", marginTop: 0, marginBottom: 8 }}>
					<span className="wau-pastilla acento">Acceso hasta {accessUntil ? fechaBonita(accessUntil) : "—"}</span>
					{puedeRegalar ? <button type="button" className="wau-btn s mini" onClick={() => { setError(null); setRegalar(true); }}>Regalar mes</button> : null}
					{error ? <span className="wau-oro" style={{ fontSize: 13.5 }}>{error}</span> : null}
				</div>
				{regalar ? <PromptModal title="Regalar mes" label="Nota" confirm="Regalar" busy={busy} onCancel={() => setRegalar(false)}
					onConfirm={(nota) => {
						setBusy(true);
						platformsService.gift(campusId, enrollmentId, nota)
							.then(() => { setRegalar(false); onChanged(); })
							.catch(e => { setError(errorText(e)); setRegalar(false); })
							.finally(() => setBusy(false));
					}} /> : null}
			</div>
		);
	};
